import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import LoginForm from "@/components/auth/LoginForm";
import { CartProvider } from "@/lib/cart";
import CustomerShell from "@/components/customer/CustomerShell";
import Home from "@/pages/customer/Home";
import ItemDetail from "@/pages/customer/ItemDetail";
import Cart from "@/pages/customer/Cart";
import OrderSuccess from "@/pages/customer/OrderSuccess";
import Account from "@/pages/customer/Account";
import PanelLayout, { AdminOnly } from "@/pages/staff/PanelLayout";
import SalesOverview from "@/pages/staff/SalesOverview";
import Dashboard from "@/pages/staff/Dashboard";
import Orders from "@/pages/staff/Orders";
import MenuAdmin from "@/pages/staff/MenuAdmin";
import Report from "@/pages/staff/Report";
import Settings from "@/pages/staff/Settings";
import AuthPage from "@/pages/staff/AuthPage";
import PosApp from "@/pos/PosApp";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Routes>
              <Route element={<CustomerShell />}>
                <Route path="/" element={<Home />} />
                <Route path="/troli" element={<Cart />} />
                <Route path="/akaun" element={<Account />} />
              </Route>
              <Route path="/menu/:id" element={<ItemDetail />} />
              <Route path="/pesanan/:id" element={<OrderSuccess />} />
              <Route path="/sign-in/*" element={<AuthPage><LoginForm mode="sign-in" /></AuthPage>} />
              <Route path="/sign-up/*" element={<AuthPage><LoginForm mode="sign-up" /></AuthPage>} />
              <Route path="/panel" element={<PanelLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="jualan" element={<AdminOnly allowSale><SalesOverview /></AdminOnly>} />
                <Route path="pesanan" element={<Orders />} />
                <Route path="menu" element={<MenuAdmin />} />
                <Route path="laporan" element={<AdminOnly><Report /></AdminOnly>} />
                <Route path="tetapan" element={<Settings />} />
              </Route>
              <Route path="/pos/*" element={<PosApp />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster position="top-center" richColors />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
